module.exports = __webpack_public_path__ + "static/media/rightGrey.02a06997.svg";